import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Section from '../../components/Section';
import FloweringArch from '../../components/FloweringArch';
import { componentsEnum } from '../../utils/types';
import {
  getFloweringArch,
  selectCurrentFloweringArch,
} from '../../ducks/floweringArch';
import { floweringArchTypesEnum } from '../../ducks/floweringArch/types';

const ShowFloweringArch = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const currentFloweringArch = useSelector(selectCurrentFloweringArch);

  useEffect(() => {
    dispatch(getFloweringArch(floweringArchTypesEnum.basedOnCurrent));
  }, []);

  return (
    <Section
      previousNav={{
        handleClick: () => history.push(
          componentsEnum.properties[componentsEnum.plantSelection].route,
        ),
      }}
      nextNav={{
        handleClick: () => history.push(
          componentsEnum.properties[componentsEnum.plantAdvice].route,
        ),
      }}
      {...props}
    >
      <Row className="justify-content-md-center">
        <Col className="text-center" md={10}>
          <h2>De bloeiboog van je gebied</h2>
          <p>
            De bloeiboog laat voor elke bijensoort de huidige
            voedselbeschikbaarheid in je gebied
            zien. Zij houdt hierbij rekening met de vliegtijd en de bloeitijd
            van de voedselplanten van de door jou geselecteerde bijen.
          </p>
          <p>
            In de tabel geven de gekleurde blokjes aan hoeveel plantensoorten er
            per halve maand beschikbaar zijn voor elke bijensoort. De
            doelstelling van de bloeiboog is dat er voor elke bijensoort 5
            verschillende plantensoorten aanwezig zijn gedurende de hele
            vliegtijd, zodat er voldoende voedsel te vinden is. Bij voldoende
            plantensoorten kleurt het blokje groen. In de tabel is de
            voedseldekking uitgedrukt in percentages en geeft voor de
            bijensoorten aan of er voldoende plantensoorten zijn om de bij in
            elke vliegmaand te voeden.
          </p>
        </Col>
      </Row>
      <FloweringArch archInfo={currentFloweringArch} showTour />
    </Section>
  );
};

export default ShowFloweringArch;
